<template>
  <el-dialog
    width="296px"
    append-to-body
    :title="title"
    :visible.sync="currentVisible"
    custom-class="h-select-dialog-wrap"
  >
    <el-scrollbar class="h-select-dialog">
      <ul class="h-select-dialog-list">
        <template v-if="auto">
          <li
            class="h-select-dialog-list-item"
            v-for="item in autoData"
            :key="item.id"
            :class="{ active: model === item.id }"
            @click.stop="onItemSelected(item)"
          >
            <span class="h-select-dialog-list-item-name">{{ item.label }}</span>
          </li>
        </template>
        <template v-else>
          <li
            class="h-select-dialog-list-item"
            v-for="item in data"
            :key="item.id"
            :class="{ active: model === item.id }"
            @click.stop="onItemSelected(item)"
          >
            <span class="h-select-dialog-list-item-name">{{ item.label }}</span>
          </li>
        </template>
      </ul>
    </el-scrollbar>
    <template slot="footer">
      <el-button @click="currentVisible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </template>
  </el-dialog>
</template>

<script>
// 项目前期 选择项暂不考虑自定义内容，所以选择项不独立写组件了
export default {
  name: "h-select-dialog",
  props: {
    value: {},
    confirmText: {
      type: String,
      default: "text"
    },
    title: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    },
    api: {
      type: String
    },
    params: {
      type: Object,
      default() {
        return {};
      }
    },
    auto: {
      type: Boolean,
      default: true
    },
    data: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      currentVisible: false,
      model: "",
      autoData: []
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(value) {
        this.currentVisible = value;
        if (value && String(this.value) !== this.model)
          this.model = String(this.value);
      }
    },
    currentVisible(value) {
      this.$emit("update:visible", value);
    },
    value: {
      immediate: true,
      handler(val, old) {
        if (String(val) !== String(old)) this.model = String(val);
      }
    }
  },
  methods: {
    select() {
      if (!this.api) return;
      this.$api(this.api, this.params)
        .then(res => {
          if (res) {
            this.autoData = res;
          }
        })
        .catch(err => {
          this.$tips(err, "error");
        });
    },
    onItemSelected(item) {
      if (item.id === this.model) return;
      this.model = item.id;
    },
    confirm() {
      let obj = {};
      if (this.auto) {
        let index = this.autoData.findIndex(item => item.id === this.model);
        obj = this.autoData[index];
      } else {
        let index = this.data.findIndex(item => item.id === this.model);
        obj = this.data[index];
      }
      this.$emit("confirm", this.model, obj);
      if (this.model == this.value) return;
      this.$emit("input", this.model);
      // this.currentVisible = false
    }
  },
  created() {
    if (this.auto) {
      this.select();
    }
  }
};
</script>

<style lang="less">
@import "../color.less";
.h-select-dialog-wrap {
  .el-dialog__body {
    padding: 20px 0 !important;
  }
}
.h-select-dialog {
  height: 108px;
  .el-scrollbar__wrap {
    overflow-x: hidden !important;
  }
  &-list {
    &-item {
      cursor: pointer;
      line-height: 36px;
      text-align: center;
      padding: 0 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &.active {
        color: @primary;
        background: @light-primary;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/select-dialog.vue